module.exports = "/media_select-d49637c2a467f86520de26d62fb88547.svg";